import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { VehicleAssignmentDTO, VehicleAssignmentResponseModel, VehicleAssignStatusDTO } from '@gtpl/shared-models/transportation';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { VehicleAssignmentAdapter } from './dto/vehicle-assignment-adapter';
import { VehicleAssignmentDto } from './dto/vehicle-assignment.dto';
import { VehicleAssignment } from './vehicle-assignment.entity';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement'
import { IndentRequest } from './dto/indent.request';
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { VehicleInfoReq, VehicleNumberReq } from './dto/vehicle-info-req';
import {HrmsEmpDetService, VehicleService} from '@gtpl/shared-services/masters'
import { CommonResponse } from '@gtpl/shared-models/masters';
import appSettings from 'apps/services/config';

let moment = require('moment');
@Injectable()
export class VehicleAssignmentService {
    constructor(
        @InjectRepository(VehicleAssignment)
        private vehicleAssignmentRepository: Repository<VehicleAssignment>,
        private vehicleAssignmentAdapter: VehicleAssignmentAdapter,
        private indentService: IndentService,
        private employeeService: HrmsEmpDetService,
        private vehicleervice: VehicleService,
    ) { }

    async getVehicleAssignDetailsByIndentId(indentRequest: IndentRequest): Promise<VehicleAssignmentResponseModel> {
        try {
            const vehicleDetails = await this.vehicleAssignmentRepository.find({ where: { indentId: indentRequest.indentId }, order: { vehicleAssignId: 'DESC' } });
            if(vehicleDetails.length>0){
                let response=[]
                let data = []
                for(const val of vehicleDetails){
                // console.log(val,'valllllllllllllll');
            response.push(new VehicleInfoReq(val.vehicleNo,val.driverId,val.driverName,val.vehicleAssignId))
        }
        data.push(new VehicleAssignmentDTO(vehicleDetails[0]?.assignedDate,vehicleDetails[0]?.harvestingDate,vehicleDetails[0]?.harvestingTime,vehicleDetails[0]?.indentId,response))
        const res = new VehicleAssignmentResponseModel(true, 11101, 'Vehicle Assignment retrived Successfully',data);
               return res;
            }
            else {
                const response = new VehicleAssignmentResponseModel(false, 11101, 'no data  found', );
                return response;
            }

        } catch (error) {
            return error;
        }
    }
    // async createVehicleAssignment(vehicleAssignmentDto: VehicleAssignmentDto, isUpdate: boolean, request: Request): Promise<VehicleAssignmentResponseModel> {
    //     try {
    //         console.log(isUpdate);
    //         // if (!isUpdate) {
    //         //     const VehicleEntity = await this.getVehAssignmentDetails(vehicleAssignmentDto.driverId,vehicleAssignmentDto.vehicleId,vehicleAssignmentDto.harvestingDate,vehicleAssignmentDto.harvestingTime,vehicleAssignmentDto.indentId);
    //         //     console.log(VehicleEntity);
    //         //     if (VehicleEntity.driverStatus && !VehicleEntity.vehicleStatus) {
    //         //         throw new ErrorResponse(11104, 'Driver already assigned for same harvesting date time. ');         
    //         //     } 
    //         //     else if (!VehicleEntity.driverStatus && VehicleEntity.vehicleStatus) {
    //         //         throw new ErrorResponse(11104, 'Vehicle already assigned for same harvesting date time. ');         
    //         //     } 
    //         //     else if (VehicleEntity.driverStatus && VehicleEntity.vehicleStatus) {
    //         //         throw new ErrorResponse(11104, 'Driver & Vehicle already assigned for same harvesting date time. ');         
    //         //     } 
    //         // }
    //         const convertedVehAssignmentEntity: VehicleAssignment = this.vehicleAssignmentAdapter.convertDtoToEntity(vehicleAssignmentDto, isUpdate);

    //         const savedDepartmentEntity: VehicleAssignment = await this.vehicleAssignmentRepository.save(
    //             convertedVehAssignmentEntity
    //         );


    //         const savedVehAssignmentDto: VehicleAssignmentDTO = this.vehicleAssignmentAdapter.convertEntityToDto(savedDepartmentEntity);

    //         if (savedVehAssignmentDto) {
    //             // generating resposnse
    //             const updateVehStatus = await this.indentService.updateVehicleStatus({ indentId: savedVehAssignmentDto.indentId, vehicleAssigned: true });

    //             if (updateVehStatus) {
    //                 const response = new VehicleAssignmentResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Vehicle Assignment Updated Successfully' : 'Vehicle Assigned Successfully', savedVehAssignmentDto);
    //                 return response;
    //             }
    //             else {
    //                 throw new ErrorResponse(11106, 'vehicle not assigned, something went wrong. ');
    //             }

    //         } else {
    //             throw new ErrorResponse(11106, 'Vehicle Assigned but issue while transforming into DTO');
    //         }
    //     } catch (error) {
    //         return error;
    //     }
    // }

    async getVehAssignmentDetails(driverId: number, vehicleId: number, harvestingDate: Date, harvestingTime: HarvestingTime, indentId: number): Promise<VehicleAssignStatusDTO> {
        const harvestDateData = moment(harvestingDate).format('YYYY-MM-DD')
        let vehicleStatus = false;
        let driverStatus = false;
        const vehicleCheck = await this.vehicleAssignmentRepository.createQueryBuilder("VehicleAssignment")
            .where("harvesting_date = '" + harvestDateData + "'")
            .andWhere("vehicle_id = " + vehicleId)
            .andWhere("indent_id != " + indentId)
            .andWhere("is_active = true")
            .andWhere("harvesting_time = '" + harvestingTime + "'").getRawMany();
        const driverCheck = await this.vehicleAssignmentRepository.createQueryBuilder("VehicleAssignment")
            .where("harvesting_date = '" + harvestDateData + "'")
            .andWhere("driver_id = " + driverId)
            .andWhere("indent_id != " + indentId)
            .andWhere("is_active = true")
            .andWhere("harvesting_time = '" + harvestingTime + "'").getRawMany();
        console.log('driverCheck' + driverCheck);

        if (vehicleCheck.length > 0) {
            vehicleStatus = true;
        }
        if (driverCheck.length > 0) {
            driverStatus = true;
        }
        return new VehicleAssignStatusDTO(vehicleStatus, driverStatus);
    }
    async createVehicleAssignment(request: VehicleAssignmentDto, isUpdate: boolean): Promise<VehicleAssignmentResponseModel> {
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            
            for(const req of request.vechileInfo){
                const entity = new VehicleAssignment()
                entity.driverId = req.driverId
                entity.driverName = req.driverName
                entity.vehicleNo = req.vehicleNum
                entity.vehicleType = request.vehicleType
                entity.createdUser = request.createdUser
                entity.createdUser = request.createdUser
                entity.isActive = request.isActive
                entity.versionFlag = request.versionFlag
                entity.iceFactory = request.iceFactory
                entity.iceQuantity = request.iceQuantity
                entity.iceType = request.iceType
                entity.harvestingDate =moment( request.harvestingDate).format('YYYY-MM-DD');
                entity.assignedDate = new Date()
                entity.harvestingTime = request.harvestingTime
                entity.indentId = request.indentId
                if(isUpdate){
                    entity.vehicleAssignId = req.vehicleAssignId
                    entity.updatedUser = request.updatedUser
                    // entity.updatedAt = request.updatedAt

                }
                // console.log(entity,'ooooooooooooo');
                const save = await transactionManager.getRepository(VehicleAssignment).save(entity)
                // console.log(save,'saveeeeeeeeee');
                
                if(!save){
                    flag.add(false);  
                }else{
                    const updateVehStatus = await this.indentService.updateVehicleStatus({ indentId: request.indentId, vehicleAssigned: true });

                    const updateDriver = await this.employeeService.updateAvalibility({id:req.driverId,isAvailable:false})
                    const updateVehicle = await this.vehicleervice.updateVehicleAvalibility({vehicleNum:req.vehicleNum,isAvailable:false})
console.log(updateVehicle,'vehicle update');

                    if(!updateDriver &&  !updateVehicle && !updateVehStatus){
                        flag.add(false);  
                    }  
                }
                
            }
            if(!flag.has(false)){
                const saveAs = isUpdate?'Updated':'Created'
                await transactionManager.completeTransaction()
                return new VehicleAssignmentResponseModel(true,1,`${saveAs} successfully `)
               
              }else{
              await transactionManager.releaseTransaction(); 
                return new VehicleAssignmentResponseModel(false, 0, "something went wrong");
              
              }
            } catch (error) {
                console.log(error);
                
            return error;
        }
    }
    async getVehicleAssignDetailsByVehicleNum(req:VehicleNumberReq): Promise<CommonResponse> {
        try {
            const vehicleDetails = await this.vehicleAssignmentRepository.find({ where: { vehicleNo: req.vehicleNum }, order: { vehicleAssignId: 'DESC' } });
            if(vehicleDetails.length>0){
                let response=[]
                let data = []
                for(const val of vehicleDetails){
                // console.log(val,'valllllllllllllll');
            response.push(new VehicleInfoReq(val.vehicleNo,val.driverId,val.driverName,val.vehicleAssignId))
        }
         const res = new CommonResponse(true, 11101, 'Vehicle Assignment retrived Successfully',response);
               return res;
            }
            else {
                const response = new CommonResponse(false, 11101, 'no data  found', );
                return response;
            }

        } catch (error) {
            return error;
        }
    }
    async getAssignedVehicleNumbers(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query= `SELECT va.vehicle_num AS vehicleNumber FROM `+ appSettings.transport_db + `.vehicle_assignment va
LEFT JOIN `+ appSettings.masters_db + `.vehicle-master v ON va.vehicle_num = v.registration_number
LEFT JOIN `+ appSettings.rm_procure_db + `.grn_items gi ON gi.indent_id = va.indent_id
WHERE v.is_available = 0 AND gi.reweighment_status =0
GROUP BY va.vehicle_num`
            const vehicleDetails = await manager.query(query);
            if(vehicleDetails.length>0){
            
         const res = new CommonResponse(true, 11101, 'Vehicle Numbers retrived Successfully',vehicleDetails);
               return res;
            }
            else {
                const response = new CommonResponse(false, 11101, 'no data  found', );
                return response;
            }

        } catch (error) {
            return error;
        }
    }
}

